(function () {
  const root = document.querySelector('[data-demi-heart-preview]');
  const options = document.querySelector('[data-demi-heart-options]');
  if (!root || !options) return;
  const canvas = root.querySelector('canvas');
  const ctx = canvas.getContext('2d');
  const status = options.querySelector('[data-demi-heart-status]');
  const viewButton = options.querySelector('[data-demi-heart-view]');
  const backButton = root.querySelector('.demi-heart-back-options');
  const monthKey = { January:'jan', February:'feb', March:'mar', April:'apr', May:'may', June:'jun', July:'jul', August:'aug', September:'sep', October:'oct', November:'nov', December:'dec' };
  const cache = new Map();
  let renderVersion = 0;
  let hasRendered = false;
  let previewVisible = false;

  const load = (src) => cache.get(src) || cache.set(src, new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error(`Demi-heart asset failed to load: ${src}`));
    image.src = new URL(src, window.location.href).href;
  })).get(src);

  function selection() {
    return {
      lower: options.querySelector('[data-demi-heart-select="lower"] input:checked')?.value,
      upper: options.querySelector('[data-demi-heart-select="upper"] input:checked')?.value,
      metal: document.querySelector('variant-selects input[type="radio"]:checked')?.value || 'Gold'
    };
  }

  function showPreview(scroll) {
    root.hidden = false;
    previewVisible = true;
    viewButton.hidden = true;
    if (scroll) requestAnimationFrame(() => root.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }));
  }

  function hidePreview() {
    root.hidden = true;
    previewVisible = false;
  }

  async function draw() {
    const version = ++renderVersion;
    const chosen = selection();
    if (!chosen.lower || !chosen.upper) {
      status.textContent = 'Choose both birthstones, then tap View preview.';
      viewButton.hidden = true;
      hidePreview();
      hasRendered = false;
      return;
    }
    status.textContent = 'Preparing your preview…';
    const keyUpper = monthKey[chosen.upper];
    const keyLower = monthKey[chosen.lower];
    let images;
    try {
      images = await Promise.all([
        load(root.getAttribute(`data-${chosen.metal.toLowerCase()}`)),
        load(root.getAttribute(`data-right-${keyUpper}`)),
        load(root.getAttribute(`data-left-${keyLower}`)),
        load(root.getAttribute(`data-${chosen.metal.toLowerCase()}-foreground`))
      ]);
    } catch (error) {
      if (version !== renderVersion) return;
      console.error(error);
      hidePreview();
      viewButton.hidden = false;
      hasRendered = false;
      status.textContent = 'Preview couldn’t load. Please try again.';
      return;
    }
    if (version !== renderVersion) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(images[0], 0, 0, canvas.width, canvas.height);
    ctx.drawImage(images[1], 0, 0, canvas.width, canvas.height);
    ctx.drawImage(images[2], 0, 0, canvas.width, canvas.height);
    ctx.drawImage(images[3], 0, 0, canvas.width, canvas.height);
    hasRendered = true;
    if (previewVisible) {
      status.textContent = 'Your preview is ready. You can update it or return to the options.';
      viewButton.hidden = true;
    } else {
      hidePreview();
      viewButton.hidden = false;
      status.textContent = 'Your preview is ready — tap View preview.';
    }
  }

  function isComplete(chosen) {
    chosen = chosen || selection();
    return Boolean(chosen.lower && chosen.upper);
  }

  function missingLabels(chosen) {
    chosen = chosen || selection();
    const missing = [];
    if (!chosen.lower) missing.push('Left Birthstone');
    if (!chosen.upper) missing.push('Right Birthstone');
    return missing;
  }

  function findProductForm() {
    return document.querySelector('product-form form[data-type="add-to-cart-form"]')
      || document.querySelector('form[data-type="add-to-cart-form"]')
      || document.querySelector('product-form form');
  }

  function updateAtcGate(chosen) {
    chosen = chosen || selection();
    const complete = isComplete(chosen);
    const form = findProductForm();
    const productForm = form ? (form.closest('product-form') || form.parentElement) : document.querySelector('product-form');
    const buttonsWrap = form
      ? form.querySelector('.product-form__buttons')
      : document.querySelector('.product-form__buttons');
    const submitBtn = form
      ? form.querySelector('button[type="submit"][name="add"], button.product-form__submit')
      : document.querySelector('button.product-form__submit');
    const gateEl = document.querySelector('[data-demi-heart-atc-gate]');

    if (buttonsWrap) buttonsWrap.classList.toggle('demi-heart-atc-incomplete', !complete);
    if (productForm) productForm.classList.toggle('demi-heart-atc-incomplete', !complete);
    if (form) form.classList.toggle('demi-heart-atc-incomplete', !complete);

    if (submitBtn) {
      if (
        submitBtn.getAttribute('data-demi-heart-gate') !== 'true'
        && submitBtn.disabled
        && /sold|unavailable/i.test((submitBtn.textContent || '').trim())
      ) {
        submitBtn.setAttribute('data-demi-heart-sold-out', 'true');
      }
      const soldOut = submitBtn.getAttribute('data-demi-heart-sold-out') === 'true';
      if (!complete || soldOut) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-disabled', 'true');
        if (!complete) submitBtn.setAttribute('data-demi-heart-gate', 'true');
      } else {
        submitBtn.disabled = false;
        submitBtn.setAttribute('aria-disabled', 'false');
        submitBtn.removeAttribute('data-demi-heart-gate');
      }
    }

    document.querySelectorAll(
      '.shopify-payment-button, .shopify-payment-button__button, accelerated-checkout, shopify-accelerated-checkout'
    ).forEach((el) => {
      if (!complete) {
        el.setAttribute('aria-disabled', 'true');
        el.setAttribute('data-demi-heart-gate', 'true');
        try { el.disabled = true; } catch (e) {}
      } else if (el.getAttribute('data-demi-heart-gate') === 'true') {
        el.removeAttribute('aria-disabled');
        el.removeAttribute('data-demi-heart-gate');
        try { el.disabled = false; } catch (e) {}
      }
    });

    if (gateEl) {
      if (complete) {
        gateEl.hidden = true;
        gateEl.textContent = '';
      } else {
        const missing = missingLabels(chosen);
        gateEl.textContent = missing.length
          ? ('Select a birth month for ' + missing.join(' and ') + ' before adding to cart.')
          : 'Select both birthstones before adding to cart.';
        gateEl.hidden = false;
      }
    }
  }

  function blockIncompleteSubmit(event) {
    const chosen = selection();
    if (isComplete(chosen)) return;
    event.preventDefault();
    event.stopPropagation();
    updateAtcGate(chosen);
    const gateEl = document.querySelector('[data-demi-heart-atc-gate]');
    if (gateEl) {
      gateEl.hidden = false;
      try { gateEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
    }
  }

  function installAtcGate() {
    const form = findProductForm();
    if (form) {
      form.addEventListener('submit', blockIncompleteSubmit, true);
    }
    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!target || !target.closest) return;
      if (!document.querySelector('.demi-heart-atc-incomplete')) return;
      if (
        target.closest('.shopify-payment-button')
        || target.closest('shopify-accelerated-checkout')
        || target.closest('accelerated-checkout')
        || target.closest('[data-shopify="payment-button"]')
      ) {
        blockIncompleteSubmit(event);
      }
    }, true);
    const buyHost = document.querySelector('product-form') || document.querySelector('.product-form__buttons');
    if (buyHost && typeof MutationObserver === 'function') {
      const mo = new MutationObserver(() => updateAtcGate(selection()));
      mo.observe(buyHost, { childList: true, subtree: true });
    }
    updateAtcGate(selection());
  }

  function handleChoiceChange() {
    const chosen = selection();
    updateAtcGate(chosen);
    const complete = Boolean(chosen.lower && chosen.upper);
    if (!complete) {
      hidePreview();
      viewButton.hidden = true;
      hasRendered = false;
      status.textContent = 'Choose both birthstones, then tap View preview.';
      return;
    }
    if (previewVisible) hidePreview();
    draw();
  }

  options.addEventListener('change', handleChoiceChange);
  document.addEventListener('change', (event) => { if (event.target.matches('variant-selects input[type="radio"]')) handleChoiceChange(); });
  viewButton.addEventListener('click', () => { if (hasRendered) showPreview(true); });
  backButton.addEventListener('click', () => {
    hidePreview();
    viewButton.hidden = !hasRendered;
    status.textContent = hasRendered ? 'Your preview is ready — tap View preview.' : 'Choose both birthstones, then tap View preview.';
    options.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });
  hidePreview();
  viewButton.hidden = true;
  installAtcGate();
})();
